import styles from './FeaturesList.module.scss';
import React from 'react';

export default function FeaturesList({ slide }) {
  return (
    <ul className={styles.list} data-aos="fade-up">
      {(slide?.description || []).map((feature, index) => (
        <li
          key={index}
          className={styles.list_block}
          data-aos="fade-up"
          data-aos-duration={(index + 1) * 500}
        >
          <h3 className={styles.list_block_title}>{feature.title}</h3>
          <div
            className={styles.list_block_text}
            dangerouslySetInnerHTML={{ __html: feature.text }}
          />
        </li>
      ))}
    </ul>
  );
}
